class ModuleSizeChart extends HTMLElement {
    connectedCallback() {


    }
    constructor() {
        super();
        this._init = this._init.bind(this);
        this.closeChart = this.closeChart.bind(this);
        this.openChart = this.openChart.bind(this);
        this.escClose = this.escClose.bind(this);
        this.pops = this.pops.bind(this);
        this._init();
        this.open = window.location.hash === '#size-chart';
    }
    get open() {
        return this.hasAttribute('open');
    }
    set open(val) {
        if (val) {
            this.setAttribute('open', '');

        } else {
            this.removeAttribute('open');
        }
        this.toggleChart();
    }

    toggleChart(){
        document.querySelector('body').style.overflow = this.open ? 'hidden':'unset';
        document.querySelector('body').classList.toggle( 'size-chart-open',this.open) ;

    }

    escClose(e){
        if (e.key === 'Escape') {
            this.open = false;
            history.pushState("", document.title, window.location.pathname + window.location.search);
            return false;
        }
    }
    closeChart(e){
        e.preventDefault();
        this.open = false;
        history.pushState("", document.title, window.location.pathname + window.location.search);
        return false;

    }

    openChart(e){
        e.preventDefault();
        this.open = true;
        window.location.hash = 'size-chart';
        return false;
    }

    pops(event){
        this.open = window.location.hash === '#size-chart';
    }
    _init(){
        window.addEventListener('popstate', this.pops);
        document.addEventListener('keydown', this.escClose);
        this.querySelectorAll('.close-size-chart').forEach((e)=>e.addEventListener('click',this.closeChart));
        this.querySelectorAll('.open-size-chart').forEach((e)=>e.addEventListener('click',this.openChart));

        document.querySelector('body').insertAdjacentHTML('afterbegin','<input type="checkbox" value="1" id="size_chart_m" style="display: none;" autocomplete="off">')
        let mes = document.querySelector('#size_chart_m');

        mes.addEventListener('change', function (checkbox) {
            localStorage.setItem('measuring_system', (0+checkbox.target.checked));
            let values = document.querySelectorAll('.size-chart-block table [data-value]')
            let state = checkbox.target.checked;
            values.forEach(function (row) {
                if (row.getAttribute('data-type') !== 'normal_bra_size') {

                    let e = row.getAttribute('data-value');
                    let b = e.replace('-',' - ').replace(/ +(?= )/g,'').trim().split(' - ');
                    let text = '';


                    if (state === true)
                        text =  b.map((x)=>Math.round(x*2.54)).join(' - ');
                    else
                        text =   b.join(' - ')+'"';

                    row.innerHTML = text;
                }
            });
        });
        if (localStorage.getItem('measuring_system')==='1') {
            mes.checked = true;
            mes.dispatchEvent(new CustomEvent('change'));
        }

    }


}

customElements.define('size-chart',ModuleSizeChart);